import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter, Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import * as angular from "angular";
import * as _ from "lodash";

require('./bringoz-package-select-list.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-package-select-list',
  templateUrl: './bringoz-package-select-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozPackageSelectListComponent implements OnInit, OnChanges {

  @Input() optionIds: string[];
  @Input() selectedType: any;
  @Input() branchIds: string[];
  @Input() depotIds: string[];
  @Input() ngPlaceholder: string;
  @Output() onChange = new EventEmitter<any>();

  public excludedMap: any;
  public queryString: any;
  public options: any;
  public optionsCopy: any;
  public sitePackageItems: any;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit(): void {
    this.sitePackageItems = this.splitService.getSitePackageItems();
    this.initOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.optionIds && !changes.optionIds.isFirstChange()) {
      this.initOptions();
    }
  }

  private initOptions() {
    if (!this.optionIds) {
      this.options = angular.copy(this.sitePackageItems);
    } else {
      this.options = [];
      _.forEach(this.sitePackageItems, (siteItem) => {
        if (_.includes(this.optionIds, siteItem.id)) {
          this.options.push(siteItem);
        }
      })
    }
    this.optionsCopy = angular.copy(this.options);
  }

  submitQuery(query) {
    this.queryString = query;
    this.options = _.filter(this.optionsCopy, (siteItem) => {
      return _.lowerCase(siteItem.name).includes(_.lowerCase(query))
    })
  }

}
